import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00001 18.5901C4.50001 16.0001 9.28001 14.0001 14 14.0001V16.5801C13.999 16.6471 14.0118 16.7137 14.0376 16.7756C14.0634 16.8375 14.1017 16.8935 14.15 16.9401L14.35 17.1401C14.3965 17.1869 14.4518 17.2241 14.5127 17.2495C14.5736 17.2749 14.639 17.288 14.705 17.288C14.771 17.288 14.8364 17.2749 14.8973 17.2495C14.9582 17.2241 15.0135 17.1869 15.06 17.1401L20.85 11.3501C20.8978 11.3052 20.936 11.2509 20.962 11.1908C20.9881 11.1306 21.0015 11.0657 21.0015 11.0001C21.0015 10.9345 20.9881 10.8696 20.962 10.8094C20.936 10.7492 20.8978 10.6949 20.85 10.6501L15.06 4.86006C15.0135 4.81319 14.9582 4.776 14.8973 4.75061C14.8364 4.72523 14.771 4.71216 14.705 4.71216C14.639 4.71216 14.5736 4.72523 14.5127 4.75061C14.4518 4.776 14.3965 4.81319 14.35 4.86006L14.15 5.06006C14.1017 5.1066 14.0634 5.16257 14.0376 5.22449C14.0118 5.28642 13.999 5.35298 14 5.42006V8.00006C11.1766 8.05026 8.47591 9.16327 6.43695 11.117C4.39799 13.0707 3.1707 15.7213 3.00001 18.5401C2.99028 18.6572 3.02214 18.7741 3.09001 18.8701C3.17574 18.9533 3.2905 18.9999 3.41001 19.0001H3.51001C3.62669 18.9996 3.73955 18.9584 3.82903 18.8835C3.91852 18.8087 3.979 18.7048 4.00001 18.5901Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgExport = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgExport;
